import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, of, forkJoin } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { Promocion, PromocionResumen } from 'src/app/model/promotion-models';

@Injectable({
  providedIn: "root",
})
export class HistoricoPromocionesService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getHistoricoXPromocionId(promocionId: number) {
    return this.http.get<any[]>(
      `${this.url}/promocion/auditoria/historico/${promocionId}`
    );
  }

  getDetalleAuditoria(auditoriaId: number) {
    return this.http.get<any>(
        `${this.url}/promocion/auditoria/${auditoriaId}`
    );
}

  // ← Helper privado para normalizar fechas sin pérdida de día
  public normalizarFecha(fecha: string): string {
    if (!fecha) return fecha;
    // Si ya es YYYY-MM-DD, devolverla tal cual sin pasar por Date
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return fecha;
    // Si tiene T, extraer solo la parte de fecha
    console.log("Fecha normalizada: ", fecha.split('T')[0]);
    return fecha.split('T')[0];
  }
}